import { cn } from "../../lib/utils";

export function StatusBadge({ label, tone = "neutral" }: { label: string; tone?: "success" | "danger" | "warning" | "neutral" }) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full px-2.5 py-1 text-xs font-semibold",
        tone === "success" && "bg-emerald-100 text-emerald-700",
        tone === "danger" && "bg-red-100 text-red-700",
        tone === "warning" && "bg-amber-100 text-amber-700",
        tone === "neutral" && "bg-slate-100 text-slate-700"
      )}
    >
      {label}
    </span>
  );
}
